import { useSelector } from 'react-redux';

import {
  REQUEST_MASTER_USER,
  SET_MASTER_USER,
  ERROR_GET_MASTER_USER,
  SET_MESSAGE_MASTER_USER,
} from './userActionTypes';

interface IState {
  busy: boolean;
  message: string;
  masterUser: any[];
}

const initialState: IState = {
  busy: false,
  message: '',
  masterUser: [],
};

const user = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_USER:
      return {
        ...state,
        busy: true,
        message: '',
      };

    case SET_MESSAGE_MASTER_USER:
      return {
        ...state,
        message: '',
      };

    case SET_MASTER_USER:
      return {
        ...state,
        busy: false,
        message: '',
        masterUser: action.payload,
      };

    case ERROR_GET_MASTER_USER:
      return {
        ...state,
        busy: false,
        message: action.payload || 'Something happened wrong try again after sometime',
      };
    default:
      return state;
  }
};

export default user;

export function useUserMaster() {
  return useSelector((state: Record<string, any>) => state.user);
}
